import api from '@/services/api'
import modules from '../../vuex-modules'

export default {
  state: {
    isLoggedIn: !!localStorage.getItem('token'),
    user: {
      userId: null,
      unityId: null,
      unityName: null,
      name: null,
      email: null,
      photo: null,
      token: null,
    },
  },

  mutations: {
    AUTH(state, user) {
      state.isLoggedIn = true
      state.user = user
    },

    LOGOUT(state) {
      state.isLoggedIn = false
      state.user = null
    },
  },

  actions: {
    async auth({ commit }, credentials) {
      try {
        this.user = credentials
        const url = `token`
        const response = await api.post(url, {
          userId: this.user.userId,
          name: this.user.name,
        })
        localStorage.setItem(
          'token',
          response && response.data ? response.data.token : null,
        )
        commit('AUTH', credentials)
      } catch (error) {
        commit('LOGOUT')
        throw error
      }
    },
    logout: ({ commit }) => {
      localStorage.removeItem('token')
      commit('LOGOUT')
    },

    cleanVuexModules: ({ commit }) => {
      commit('CLEAN_MODULES')
    },
  },

  getters: {
    isLoggedIn: (state) => state.isLoggedIn,
    user: (state) => state.user,
  },
}
